import { deviceTypes } from '@styles/mediaQueries';
import styled from 'styled-components';
import { MarkdownOrText } from './MarkdownOrText';

export const StyledMarkdownOrText = styled(MarkdownOrText)`
  display: flex;
  row-gap: 1rem;
  flex-direction: column;
  --fontsize-md: 14px;
  --i-fontsize-sm: 12px;
  --col: #474d66;

  & > * {
    margin-top: 0;
    margin-bottom: 0;
    color: var(--col);
  }

  ul,
  ol {
    padding-left: 1rem;
    list-style-position: inside;
  }

  h4,
  h5 {
    font-size: var(--i-fontsize-sm);
  }

  hr {
    border: 1px solid #e6e8f0;
  }
  /* Support for older descriptions that have some markdown */
  & > p:only-child {
    white-space: pre-wrap;
  }

  [data-device='${deviceTypes.mobile}'] & {
    --fontsize-md: 12px;

    h4,
    h5 {
      --i-fontsize-sm: 12px;
    }
  }
`;
